<section class="skills-section py-5" id="skills">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 mx-auto text-center mb-5">
        <h2 class="section-title">{{ i18n.getTranslation('skills.title') }}</h2>
        <p class="section-subtitle">{{ i18n.getTranslation('skills.subtitle') }}</p>
      </div>
    </div>

    <div class="row">
      <!-- Frontend Skills -->
      <div class="col-lg-6 mb-4">
        <div class="skills-category">
          <h4 class="category-title">
            <i class="fas fa-code text-primary me-2"></i>
            {{ i18n.getTranslation('skills.categories.frontend') }}
          </h4>
          <div class="skills-grid">
            <div class="skill-item" *ngFor="let skill of frontendSkills">
              <div class="skill-icon">
                <i [class]="skill.icon"></i>
              </div>
              <span class="skill-name">{{ skill.name }}</span>
              <div class="skill-level">
                <div class="skill-bar">
                  <div class="skill-progress" [style.width.%]="skill.level"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Backend Skills -->
      <div class="col-lg-6 mb-4">
        <div class="skills-category">
          <h4 class="category-title">
            <i class="fas fa-server text-primary me-2"></i>
            {{ i18n.getTranslation('skills.categories.backend') }}
          </h4>
          <div class="skills-grid">
            <div class="skill-item" *ngFor="let skill of backendSkills">
              <div class="skill-icon">
                <i [class]="skill.icon"></i>
              </div>
              <span class="skill-name">{{ skill.name }}</span>
              <div class="skill-level">
                <div class="skill-bar">
                  <div class="skill-progress" [style.width.%]="skill.level"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Database Skills -->
      <div class="col-lg-6 mb-4">
        <div class="skills-category">
          <h4 class="category-title">
            <i class="fas fa-database text-primary me-2"></i>
            {{ i18n.getTranslation('skills.categories.database') }}
          </h4>
          <div class="skills-grid">
            <div class="skill-item" *ngFor="let skill of databaseSkills">
              <div class="skill-icon">
                <i [class]="skill.icon"></i>
              </div>
              <span class="skill-name">{{ skill.name }}</span>
              <div class="skill-level">
                <div class="skill-bar">
                  <div class="skill-progress" [style.width.%]="skill.level"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cloud & DevOps Skills -->
      <div class="col-lg-6 mb-4">
        <div class="skills-category">
          <h4 class="category-title">
            <i class="fas fa-cloud text-primary me-2"></i>
            {{ i18n.getTranslation('skills.categories.cloud') }}
          </h4>
          <div class="skills-grid">
            <div class="skill-item" *ngFor="let skill of cloudSkills">
              <div class="skill-icon">
                <i [class]="skill.icon"></i>
              </div>
              <span class="skill-name">{{ skill.name }}</span>
              <div class="skill-level">
                <div class="skill-bar">
                  <div class="skill-progress" [style.width.%]="skill.level"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
